import { render, staticRenderFns } from "./FinanceDashboardTab.vue?vue&type=template&id=1746d9d4&"
import script from "./FinanceDashboardTab.vue?vue&type=script&lang=js&"
export * from "./FinanceDashboardTab.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDashboardTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports